import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { mappingResultError, NotFoundError, Result, UseCase } from '@digibricks/core';
import { EssayQuestion, SpeakingQuestion, SingleChoiceQuestion, MultipleChoiceQuestion, FillInBlankQuestion, QuestionType, Score, QuestionStatus, MatchingQuestion, PreviousQuestionId } from '../../../domain';
import { cloneDeep } from 'lodash';
export var CREATE_QUESTION_USE_CASE = 'CREATE_QUESTION_USE_CASE';
export var CreateQuestionUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(CreateQuestionUseCase, _UseCase);

  var _super = _createSuper(CreateQuestionUseCase);

  function CreateQuestionUseCase() {
    _classCallCheck(this, CreateQuestionUseCase);

    return _super.apply(this, arguments);
  }

  _createClass(CreateQuestionUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var data, currentQuestions, currentHeadings, previousQuestionId, headingId, nextHeadingId, newQuestions, newQuestionOrError, nextQuestion, newQuestion, nextQuestionOrError, newHeadings, heading, nextHeading;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = input.data, currentQuestions = input.currentQuestions, currentHeadings = input.currentHeadings;
                previousQuestionId = data.previousQuestionId, headingId = data.headingId, nextHeadingId = data.nextHeadingId;
                newQuestions = cloneDeep(_toConsumableArray(currentQuestions));
                newQuestionOrError = this.createQuestion(data);

                if (!newQuestionOrError.isFailure) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", mappingResultError(newQuestionOrError));

              case 6:
                nextQuestion = null;
                newQuestion = newQuestionOrError.getValue();
                newQuestions.push(newQuestion);
                nextQuestionOrError = this.updateNextQuestion(newQuestion, currentQuestions, previousQuestionId);

                if (nextQuestionOrError.isFailure) {
                  nextQuestion = null;
                } else {
                  nextQuestion = nextQuestionOrError.getValue();
                  newQuestions = newQuestions.filter(function (q) {
                    return q.id.toString() !== nextQuestion.id.toString();
                  });
                  newQuestions.push(nextQuestion);
                }

                if (!currentHeadings) {
                  _context.next = 16;
                  break;
                }

                newHeadings = cloneDeep(_toConsumableArray(currentHeadings));

                if (headingId) {
                  heading = currentHeadings.find(function (h) {
                    return h.id.toString() === headingId;
                  });

                  if (heading) {
                    newHeadings = newHeadings.filter(function (h) {
                      return h.id.toString() !== headingId;
                    });
                    heading.updateNextQuestionId(newQuestion.id.toString());
                    newHeadings.push(heading);
                  }
                }

                if (nextHeadingId) {
                  nextHeading = currentHeadings.find(function (h) {
                    return h.id.toString() === nextHeadingId;
                  });

                  if (nextHeading) {
                    newHeadings = newHeadings.filter(function (h) {
                      return h.id.toString() !== nextHeadingId;
                    });
                    nextHeading.updatePreviousQuestionId(newQuestion.id.toString());
                    newHeadings.push(nextHeading);
                  }
                }

                return _context.abrupt("return", Result.ok({
                  newQuestion: newQuestion,
                  nextQuestion: nextQuestion,
                  newHeadings: newHeadings,
                  questions: newQuestions
                }));

              case 16:
                return _context.abrupt("return", Result.ok({
                  newQuestion: newQuestion,
                  nextQuestion: nextQuestion,
                  questions: newQuestions
                }));

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }, {
    key: "createQuestion",
    value: function createQuestion(data) {
      var type = data.type;

      switch (type) {
        case QuestionType.Essay:
          return EssayQuestion.create(_objectSpread(_objectSpread({}, data), {}, {
            score: Score["default"],
            status: QuestionStatus.New
          }));

        case QuestionType.Speaking:
          return SpeakingQuestion.createDefault(_objectSpread(_objectSpread({}, data), {}, {
            score: data.score ? Score.create(data.score).getValue() : Score["default"],
            status: QuestionStatus.New
          }));

        case QuestionType.SingleChoice:
          return SingleChoiceQuestion.createDefault(_objectSpread(_objectSpread({}, data), {}, {
            score: data.score ? Score.create(data.score).getValue() : Score["default"],
            status: QuestionStatus.New
          }));

        case QuestionType.MultipleChoice:
          return MultipleChoiceQuestion.createDefault(_objectSpread(_objectSpread({}, data), {}, {
            score: data.score ? Score.create(data.score).getValue() : Score["default"],
            status: QuestionStatus.New
          }));

        case QuestionType.FillInBlank:
          return FillInBlankQuestion.createDefault(_objectSpread(_objectSpread({}, data), {}, {
            score: data.score ? Score.create(data.score).getValue() : Score["default"],
            status: QuestionStatus.New
          }));

        case QuestionType.Matching:
          return MatchingQuestion.createDefault(_objectSpread(_objectSpread({}, data), {}, {
            score: data.score ? Score.create(data.score).getValue() : Score["default"],
            status: QuestionStatus.New
          }));
      }
    }
  }, {
    key: "updateNextQuestion",
    value: function updateNextQuestion(newQuestion, existingQuestions, previousQuestionId) {
      var previousQuestionIdToUse = previousQuestionId !== null && previousQuestionId !== void 0 ? previousQuestionId : PreviousQuestionId.none.id.toString();
      var nextQuestion = existingQuestions.find(function (q) {
        var _q$previousQuestionId;

        return (((_q$previousQuestionId = q.previousQuestionId) === null || _q$previousQuestionId === void 0 ? void 0 : _q$previousQuestionId.toString()) || PreviousQuestionId.none.id.toString()) === previousQuestionIdToUse && q.sectionId === newQuestion.sectionId;
      });

      if (!nextQuestion) {
        return new NotFoundError('No next question found');
      }

      var updatedResult = nextQuestion.updatePreviousQuestionId(newQuestion.id.toString());

      if (updatedResult.isFailure) {
        return mappingResultError(updatedResult);
      }

      return Result.ok(nextQuestion);
    }
  }]);

  return CreateQuestionUseCase;
}(UseCase);